import { GetFundDetailsType, CreateFundType, SetFundToResumeType } from "./types";

export const getFundDetailsSlr = (state: any): GetFundDetailsType => state.fundDetails.getFundDetails;
export const getFundDetailsForModalSlr = (state: any): GetFundDetailsType => state.fundDetails.getFundDetailsForModal;
export const createFundSlr = (state: any): CreateFundType => state.fundDetails.createFund;
export const setFundToResumeSlr = (state: any): SetFundToResumeType => state.fundDetails.setFundToResume;
